import React from 'react';
import { useParams } from 'react-router-dom';

const AndroidViewer = () => {


  const { glb } = useParams();
  const { sessionId } = useParams();
  const containerStyle = {
    width: '80%',
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f0f0',
  };

  const modelViewerStyle = {
    width: '100%',
    height: '300px',
    border: '1px solid #ccc',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={containerStyle}>
      <model-viewer
        alt=""
        src={glb}
        ar
        shadow-intensity="1"
        camera-controls
        touch-action="pan-y"
        style={modelViewerStyle}
      ></model-viewer>
    </div>
  );
};

export default AndroidViewer;
